function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#F17071"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 5.883V12H2V5.82L0 4.695V13a1 1 0 001 1h14a1 1 0 001-1V4.783l-2 1.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 0H1C.4 0 0 .4 0 1v1.4l8 4.5 8-4.4V1c0-.6-.4-1-1-1z"
}));

function SvgStaffEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTUiPgogICAgPGcgZmlsbD0iI0YxNzA3MSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICA8cGF0aCBkPSJNMTQgNS44ODNWMTJIMlY1LjgyTDAgNC42OTVWMTNhMSAxIDAgMDAxIDFoMTRhMSAxIDAgMDAxLTFWNC43ODNsLTIgMS4xeiIgLz4KICAgICAgICA8cGF0aCBkPSJNMTUgMEgxQy40IDAgMCAuNCAwIDF2MS40bDggNC41IDgtNC40VjFjMC0uNi0uNC0xLTEtMXoiIC8+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgStaffEmail as ReactComponent };